import { CurvedDivider } from "#components/CurvedDivider";
import { ParallaxSection } from "#components/ParallaxSection";
import { AboutSection } from "#sections/AboutSection";
import { AudienceGateway } from "#sections/AudienceGateway";
import { HeroSection } from "#sections/HeroSection";
import HowItWorks from "#sections/HowItWorks";
import IQAAssessments from "#sections/IQAAssessments";
import PartnersSection from "#sections/Partners";
import ProductShowcase from "#sections/ProductShowcase";
import QuestionnaireSlider from "#sections/QuestionsAndAnswers";
import SocialProofBar from "#sections/SocialProofBar";
import WhatWeDo from "#sections/WhatWeDo";
import React from "react";

function HomePage() {
  return (
    <>
      {/* Hero: Business Operations Automation positioning */}
      <HeroSection />

      {/* Social Proof: Hard metrics strip — builds instant credibility */}
      <SocialProofBar />

      {/* Audience Gateway: Overlaps Hero slightly for modern feel */}
      <AudienceGateway />

      <CurvedDivider flip />

      {/* Product Showcase: Three flagship products */}
      <ParallaxSection offsetY={20}>
        <ProductShowcase />
      </ParallaxSection>

      <CurvedDivider />

      {/* How It Works: 5-step process timeline */}
      <HowItWorks />

      <CurvedDivider flip />

      {/* About Section: Systems integration roots, hands-on approach */}
      <ParallaxSection offsetY={20}>
        <AboutSection />
      </ParallaxSection>

      <CurvedDivider />

      <ParallaxSection offsetY={20}>
        <WhatWeDo />
      </ParallaxSection>

      <CurvedDivider flip />

      <ParallaxSection offsetY={30}>
        <QuestionnaireSlider />
      </ParallaxSection>

      <CurvedDivider />

      <ParallaxSection offsetY={20}>
        <IQAAssessments />
      </ParallaxSection>

      <CurvedDivider flip />

      <ParallaxSection offsetY={20}>
        <PartnersSection />
      </ParallaxSection>
    </>
  );
}

export default HomePage;
